import Member from 'src/entities/Member';

import Environment from '../common/Environment';
import AuthResultJson from '../jsons/AuthResultJson';

export default class SigninMember {
  execute(member: Member): Promise<Member> {
    const method: string = 'POST';
    const path = Environment.server() + '/member/signin';

    return new Promise((resolve, reject) => {
      fetch(path, {
        method,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          member
        })
      })
        .then(response => {
          if (response.ok) {
            return response.json();
          } else {
            reject(response.status);
            return null;
          }
        })
        .then((responseJson: AuthResultJson) => {
          if (
            responseJson.api === undefined ||
            responseJson.api.status === undefined
          ) {
            reject('Server Error');
          } else if (responseJson.api.status === 'success') {
            resolve(responseJson.member);
          } else {
            reject(responseJson.api.errorMessage);
          }
        })
        .catch(error => {
          console.log(error.message);
          reject(`Unable to reach server.\n${error.message}`);
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/apis/SigninMember.ts